import React, { useState } from 'react';
import {
  Building2,
  ChevronDown,
  Copy,
  FileJson,
  FileText,
  Link2,
  Megaphone,
  Plus,
  Sparkles,
} from 'lucide-react';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { cn } from '../../lib/utils';

const PRIMARY_OPTIONS = [
  { id: 'scratch', label: 'Start from Scratch', icon: Plus },
  { id: 'ai', label: 'Build Using AI', icon: Sparkles },
  { id: 'template', label: 'Select from Template', icon: FileText },
];

const IMPORT_OPTIONS = [
  { id: 'import-file', label: 'Import from file', icon: FileJson },
  { id: 'import-url', label: 'Import from URL', icon: Link2 },
];

const SECONDARY_OPTIONS = [
  { id: 'import-campaign', label: 'Import from a campaign', icon: Megaphone },
  { id: 'company', label: 'Company based workflow', icon: Building2 },
];

const WorkflowCreateDropdown = ({ onSelect, className }) => {
  const [open, setOpen] = useState(false);

  const handleSelect = (optionId) => {
    setOpen(false);
    onSelect?.(optionId);
  };

  const renderOption = (option) => (
    <DropdownMenuItem
      key={option.id}
      data-testid={`create-workflow-option-${option.id}`}
      className="text-zinc-200 focus:bg-zinc-800 focus:text-white"
      onSelect={(e) => {
        e.preventDefault();
        handleSelect(option.id);
      }}
    >
      <option.icon className="mr-2 h-4 w-4" />
      {option.label}
    </DropdownMenuItem>
  );

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <div className={cn('flex', className)}>
        <Button
          type="button"
          className="rounded-r-none bg-emerald-600 hover:bg-emerald-700"
          data-testid="create-workflow-primary"
          onClick={() => handleSelect('scratch')}
        >
          <Plus className="mr-2 h-4 w-4" />
          Create Workflow
        </Button>
        <DropdownMenuTrigger asChild>
          <Button
            type="button"
            className="rounded-l-none border-l border-emerald-700 bg-emerald-600 px-2 hover:bg-emerald-700"
            data-testid="create-workflow-dropdown-trigger"
            aria-label="More create options"
          >
            <ChevronDown className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
      </div>
      <DropdownMenuContent
        align="end"
        className="w-64 border-zinc-700 bg-zinc-900"
        data-testid="create-workflow-dropdown-menu"
      >
        {PRIMARY_OPTIONS.map(renderOption)}
        <DropdownMenuSeparator className="bg-zinc-700" data-testid="create-workflow-import-separator" />
        {IMPORT_OPTIONS.map(renderOption)}
        <DropdownMenuSeparator className="bg-zinc-700" />
        {SECONDARY_OPTIONS.map(renderOption)}
        <DropdownMenuSeparator className="bg-zinc-700" />
        <DropdownMenuItem
          data-testid="create-workflow-option-duplicate"
          className="text-zinc-200 focus:bg-zinc-800 focus:text-white"
          onSelect={(e) => {
            e.preventDefault();
            handleSelect('duplicate');
          }}
        >
          <Copy className="mr-2 h-4 w-4" />
          Duplicate Existing Workflow
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default WorkflowCreateDropdown;
